import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import icons from "./Icons.js";
import Box from "@mui/material/Box";
import Tooltip from "../Tooltip/Tooltip.js";
const DOMAIN = /^[a-z0-9-]+(\.[a-z0-9-]+)+$/;
const lookupKeys = (type) => {
  const domain = type.trim().toLowerCase();
  if (!DOMAIN.test(domain)) return [type];
  const labels = domain.split(".");
  return [type, ...labels.slice(0, -1).map((_, i) => labels.slice(i).join("."))];
};
const iconFor = (type) => {
  switch (type) {
    case "Facebook Ads":
      return /* @__PURE__ */ jsx(icons.FacebookAds, {});
    case "Google Ads":
      return /* @__PURE__ */ jsx(icons.GoogleAds, {});
    case "LinkedIn Ads":
      return /* @__PURE__ */ jsx(icons.LinkedInAds, {});
    case "TikTok Ads":
      return /* @__PURE__ */ jsx(icons.TiktokAds, {});
    case "Instagram Ads":
      return /* @__PURE__ */ jsx(icons.InstagramAds, {});
    case "Microsoft Advertising (Bing)":
    case "Microsoft Ads":
      return /* @__PURE__ */ jsx(icons.MicrosoftAds, {});
    case "MetaAds":
    case "Meta Ads":
      return /* @__PURE__ */ jsx(icons.MetaAds, {});
    case "DV360":
      return /* @__PURE__ */ jsx(icons.DV360, {});
    case "ChatGPT":
    case "chatgpt.com":
    case "chat.openai.com":
    case "openai.com":
    case "ChatGPT Ads":
    case "chatgpt_gui":
      return /* @__PURE__ */ jsx(icons.ChatGPT, {});
    case "Gemini":
    case "gemini.google.com":
    case "Google AI Overview":
    case "google_ai_overview":
    case "google_gemini_gui":
      return /* @__PURE__ */ jsx(icons.Gemini, {});
    case "Claude":
    case "claude.ai":
    case "anthropic.com":
    case "anthropic_claude_4_5_haiku":
      return /* @__PURE__ */ jsx(icons.Claude, {});
    case "Deepseek":
    case "DeepSeek":
    case "deepseek.com":
      return /* @__PURE__ */ jsx(icons.Deepseek, {});
    case "Perplexity":
    case "perplexity.ai":
    case "perplexity.com":
      return /* @__PURE__ */ jsx(icons.Perplexity, {});
    case "Microsoft Copilot":
    case "copilot.microsoft.com":
    case "copilot.com":
    case "edgeservices.bing.com":
    case "Bing Copilot":
      return /* @__PURE__ */ jsx(icons.MicrosoftCopilot, {});
    case "Huggingface":
    case "Hugging Face":
    case "huggingface.co":
      return /* @__PURE__ */ jsx(icons.Huggingface, {});
    case "writesonic.com":
    case "writesonic.ai":
    case "Writesonic":
      return /* @__PURE__ */ jsx(icons.Writesonic, {});
    case "copy.ai":
    case "Copy.ai":
      return /* @__PURE__ */ jsx(icons.CopyAi, {});
    case "Google AI Mode":
    case "google_ai_mode_gui":
      return /* @__PURE__ */ jsx(icons.GoogleAiMode, {});
    case "You.com":
    case "you.com":
      return /* @__PURE__ */ jsx(icons.YouCom, {});
    case "Grok":
    case "grok.com":
      return /* @__PURE__ */ jsx(icons.Grok, {});
    case "Meta AI":
    case "meta.ai":
      return /* @__PURE__ */ jsx(icons.MetaAi, {});
    case "Mistral":
    case "Le Chat":
    case "mistral.ai":
      return /* @__PURE__ */ jsx(icons.Mistral, {});
    case "Poe":
    case "poe.com":
      return /* @__PURE__ */ jsx(icons.Poe, {});
    case "Qwen":
    case "qwen.ai":
      return /* @__PURE__ */ jsx(icons.Qwen, {});
    case "Kimi":
    case "kimi.com":
      return /* @__PURE__ */ jsx(icons.Kimi, {});
    case "Duck.ai":
    case "duck.ai":
      return /* @__PURE__ */ jsx(icons.DuckDuckGo, {});
    default:
      return null;
  }
};
const CellIcon = (t0) => {
  const $ = c(5);
  const {
    type
  } = t0;
  let t1;
  if ($[0] !== type) {
    t1 = typeof type === "string" ? lookupKeys(type).map(iconFor).find(Boolean) ?? null : null;
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconComponent = t1;
  let t2;
  if ($[2] !== iconComponent || $[3] !== type) {
    t2 = iconComponent ? /* @__PURE__ */ jsx(Tooltip, { title: type, children: /* @__PURE__ */ jsx(Box, { sx: {
      width: 20,
      height: 20
    }, children: iconComponent }) }) : null;
    $[2] = iconComponent;
    $[3] = type;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export {
  CellIcon as default
};
